import {useCallback} from 'react';

/**
 * Custom hook for IMask input handling
 * Encapsulates mask conversion and change handling logic
 *
 * @param onChange - Optional change handler
 * @returns Object with handleAccept function
 *
 * @example
 * ```tsx
 * const { handleAccept } = useIMaskInput(onChange);
 *
 * <IMaskInput
 *   mask="00.000.000/0000-00"
 *   onAccept={handleAccept}
 * />
 * ```
 */
export const useIMaskInput = (
  onChange?: (event: {target: {value: string}}) => void
) => {
  /**
   * Memoized handler to prevent unnecessary re-renders
   * Converts IMask's onAccept to standard onChange format
   */
  const handleAccept = useCallback(
    (acceptedValue: string): void => {
      if (onChange) {
        onChange({target: {value: acceptedValue}});
      }
    },
    [onChange]
  );

  return {
    handleAccept
  };
};
